import { render } from "./QrCodeScreen.vue?vue&type=template&id=7d970ae4&scoped=true&lang=html"
import script from "./QrCodeScreen.vue?vue&type=script&lang=js"
export * from "./QrCodeScreen.vue?vue&type=script&lang=js"

import "./QrCodeScreen.vue?vue&type=style&index=0&id=7d970ae4&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_aethon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d970ae4"]])

export default __exports__